import Store from "../../../../../../Store";
import lv from "./images/lv.png";

export const mockImages = { lv };

export const getMockImage = () => {
  const short = Store.getUserPlatformLangShort();
  return mockImages[short];
};
